import { render, staticRenderFns } from "./PollutantLayer.vue?vue&type=template&id=2e55b87a&scoped=true&"
import script from "./PollutantLayer.vue?vue&type=script&lang=js&"
export * from "./PollutantLayer.vue?vue&type=script&lang=js&"
import style0 from "./PollutantLayer.vue?vue&type=style&index=0&id=2e55b87a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e55b87a",
  null
  
)

export default component.exports